import { Routes, Route } from "react-router-dom";
import Chat from "../chat/Chat";
import { SystemPromptProvider } from "../../features/SystemPrompt";
import { ConversationExporterProvider } from "../../features/ConversationExporter";

import styles from "./Layout.module.css";
import NoPage from "../NoPage";

const Layout = () => {
  return (
    <SystemPromptProvider>
      <ConversationExporterProvider>
        <div className={styles.layout}>
          <Routes>
            <Route index element={<Chat />} />
            <Route path="*" element={<NoPage />} />
          </Routes>
        </div>
      </ConversationExporterProvider>
    </SystemPromptProvider>
  );
};

export default Layout;
